import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";
import { app } from "../Frame/App";

export class RadioGroupControl extends BaseControl {

    constructor(protected inputs: Array<HTMLInputElement>, controller: Controller, field: string, protected isBoolean: boolean) {
        super(controller, field);

        if (controller.automaticUpdateModel) {
            for (let input of this.inputs) {
                input.addEventListener("click", this.onClick);
            }
        }
    }

    onClick = (ev: Event) => {
        if (this.isBoolean) {
            let value = ((ev.currentTarget as HTMLElement).getAttribute("value") == "true");
            this.saveValue(value);
        }
        else {
            let value = app.anyToInt((ev.currentTarget as HTMLElement).getAttribute("value"));
            this.saveValue(value);
        }
    }

    dispose() {
        if (this.controller.automaticUpdateModel) {
            for (let input of this.inputs) {
                input.removeEventListener("click", this.onClick);
            }
        }
    }

    updateControlFromModel() {
        let value = this.getModelValue();
        if (this.isBoolean) {
            if (value == null) {
                value = false;
            }
            for (let input of this.inputs) {
                if (value == (input.getAttribute("value") == "true")) {
                    input.checked = true;
                    return;
                }
            }
        }
        else {
            for (let input of this.inputs) {
                if (value == app.anyToInt(input.getAttribute("value"))) {
                    input.checked = true;
                    return;
                }
            }
        }
    }

    updateModelFromControl() {
        if (this.isBoolean) {
            for (let input of this.inputs) {
                if (input.checked) {
                    this.setModelValue(input.getAttribute("value") == "true");
                    break;;
                }
            }
        }
        else {
            for (let input of this.inputs) {
                if (input.checked) {
                    this.setModelValue(app.anyToInt(input.getAttribute("value")));
                    break;;
                }
            }
        }
    }

    validate() {
    }

    focus() {
        this.inputs[0].focus();
    }
}
